import React, { useEffect, useState, useRef } from 'react';
import GeneratePdf from '../../../../components/GeneratePdf';
import { getFormatedNumber } from '../../../../services/appService';
import GenerateExcel from "../../../../components/GenerateExcel";
import { useDispatch, useSelector } from 'react-redux';
import { getInsuranceInfoRpt, loadInsuranceInfoRpt } from '../../../store/reports';
import Moment from 'react-moment';
import { Modal } from 'react-bootstrap';
import SearchableSelect from '../../../../comman/SearchableSelect';

const InsuranceInformation = () => {
    const [parterInsuranceReports, setParterInsuranceReports] = useState([]);
    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [excelShowHide, setExcelShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState("");
    const [selectedColData, setSelectedColData] = useState([]);
    const [selectedInsuranceType, setSelectedInsuranceType] = useState(0);
    const [insuranceExpired, setInsuranceExpired] = useState(0);
    const [isLoading, setIsLoading] = useState(false);

    // Popup Modal State
    const [activeDetailsItem, setActiveDetailsItem] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);

    // Search & Clipboard state
    const [tableSearchTerm, setTableSearchTerm] = useState("");
    const [copiedText, setCopiedText] = useState("");

    // Dual Scrollbars Synchronization
    const [tableWidth, setTableWidth] = useState(0);
    const topScrollRef = useRef(null);
    const tableWrapperRef = useRef(null);

    const insuranceTypes = [
        { id: 1, name: "Sub-Contractors", pmId: 3 },
        { id: 2, name: "Recruiters", pmId: 5 }
    ];

    const expirationOptions = [
        { id: 0, name: "Expiration Status" },
        { id: 1, name: "Expired" },
        { id: 2, name: "Active" },
        { id: 3, name: "Data not submitted" }
    ];

    const insuranceInfoRptSelector = useSelector(getInsuranceInfoRpt);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedInsuranceType === 0) {
            setParterInsuranceReports([]);
            return;
        }
        setParterInsuranceReports(insuranceInfoRptSelector || []);
        setIsLoading(false);
    }, [insuranceInfoRptSelector]);

    const copyToClipboard = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text);
        setCopiedText(text);
        setTimeout(() => setCopiedText(""), 2000);
    };

    const handleInsuranceTypeSelect = (pmId) => {
        if (isLoading || Number(selectedInsuranceType) === pmId) return;
        setSelectedInsuranceType(pmId);
        setParterInsuranceReports([]);
        setIsLoading(true);
        dispatch(loadInsuranceInfoRpt(pmId, insuranceExpired, 0, 0));
        setTableSearchTerm("");
    };

    const handleInsuranceExpiredChange = (e) => {
        const rawVal = e?.target?.value ?? e;
        const parsed = parseInt(rawVal);
        const val = isNaN(parsed) ? 0 : parsed;
        setInsuranceExpired(val);
        setParterInsuranceReports([]);
        if (selectedInsuranceType !== 0) {
            setIsLoading(true);
            dispatch(loadInsuranceInfoRpt(selectedInsuranceType, val, 0, 0));
        }
    };

    const handleViewDetails = (item) => {
        setActiveDetailsItem(item);
        setShowDetailsModal(true);
    };

    const handleCloseDetailsModal = () => {
        setActiveDetailsItem(null);
        setShowDetailsModal(false);
    };

    const getFilteredReports = () => {
        if (!parterInsuranceReports) return [];
        return parterInsuranceReports.filter(item => {
            const term = tableSearchTerm.toLowerCase();
            const companyName = (item.name || "").toLowerCase();
            const keyName = (item.keyName || "").toLowerCase();
            const insurer = (item.insuranceCompany || "").toLowerCase();
            const email = (item.email || "").toLowerCase();
            const idVal = String(item.id || "").toLowerCase();

            return companyName.includes(term) ||
                keyName.includes(term) ||
                insurer.includes(term) ||
                email.includes(term) ||
                idVal.includes(term);
        });
    };

    const filteredReports = getFilteredReports();

    // Stats calculations
    const getKpiStats = () => {
        if (!parterInsuranceReports || parterInsuranceReports.length === 0) {
            return { totalCount: 0, uniqueInsurers: 0, expiredCount: 0, activeCount: 0 };
        }
        const totalCount = parterInsuranceReports.length;
        const uniqueInsurers = new Set(
            parterInsuranceReports
                .map((item) => (item.insuranceCompany || "").trim().toLowerCase())
                .filter((b) => b !== "")
        ).size;

        let expiredCount = 0;
        let activeCount = 0;

        parterInsuranceReports.forEach((item) => {
            if (item.insuranceDetails && item.insuranceDetails.length > 0) {
                const hasExpired = item.insuranceDetails.some(d => d.daysRemaining !== null && d.daysRemaining <= 0);
                if (hasExpired) {
                    expiredCount++;
                } else {
                    activeCount++;
                }
            }
        });

        return { totalCount, uniqueInsurers, expiredCount, activeCount };
    };

    const { totalCount, uniqueInsurers, expiredCount, activeCount } = getKpiStats();

    // Dual scrollbar sync logic
    const handleTopScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            tableWrapperRef.current.scrollLeft = topScrollRef.current.scrollLeft;
        }
    };

    const handleTableScroll = () => {
        if (topScrollRef.current && tableWrapperRef.current) {
            topScrollRef.current.scrollLeft = tableWrapperRef.current.scrollLeft;
        }
    };

    useEffect(() => {
        const updateWidth = () => {
            const table = document.getElementById("sub_ach_rpt");
            if (table) {
                setTableWidth(table.scrollWidth);
            }
        };

        updateWidth();
        const timer = setTimeout(updateWidth, 500);

        window.addEventListener("resize", updateWidth);
        return () => {
            window.removeEventListener("resize", updateWidth);
            clearTimeout(timer);
        };
    }, [filteredReports, selectedInsuranceType]);

    const subcontractorExportPDF = () => {
        let headers = [
            [
                "ID",
                "Company Name",
                "Company Email",
                "Company Phone",
                "Insurance Company",
                "Insurance Details",
                "Key Contact ID",
                "Key Contact Name",
                "Key Contact Email",
                "Key Contact Phone",
            ],
        ];

        let data = [];
        filteredReports.map((item) => {
            data.push([
                item.id || "",
                item.name || "",
                item.email || "",
                item.phone || "",
                item.insuranceCompany || "",
                "",
                item.keyId || "",
                item.keyName || "",
                item.keyEmail || "",
                item.keyPhone || "",
            ]);

            if (item.insuranceDetails && item.insuranceDetails.length > 0) {
                data.push([
                    "",
                    "",
                    "Type",
                    "Policy #",
                    "Expiration",
                    "Remaining Days",
                    "",
                    "",
                ]);
                item.insuranceDetails.forEach((detail) => {
                    data.push([
                        "",
                        "",
                        `${detail.coverageType || ""}`,
                        `${detail.policyNumber || ""}`,
                        `${detail.expirationDate
                            ? new Date(detail.expirationDate).toLocaleDateString()
                            : "N/A"
                        }`,
                        `${detail.daysRemaining || "N/A"}`,
                        "",
                        "",
                    ]);
                });
            }
        });

        setSelectedCol(headers);
        setSelectedColData(data);
        setPdfShowHide(true);
    }

    const subcontractorExportExcel = () => {
        let headers = [
            [
                "ID",
                "Company Name",
                "Company Email",
                "Company Phone",
                "Insurance Company",
                "Insurance Details",
                "Key Contact ID",
                "Key Contact Name",
                "Key Contact Email",
                "Key Contact Phone",
            ],
        ];

        let data = [];
        filteredReports.forEach((item) => {
            data.push([
                item.id || "",
                item.name || "",
                item.email || "",
                item.phone || "",
                item.insuranceCompany || "",
                "",
                item.keyId || "",
                item.keyName || "",
                item.keyEmail || "",
                item.keyPhone || "",
            ]);

            if (item.insuranceDetails && item.insuranceDetails.length > 0) {
                data.push([
                    "",
                    "",
                    "Type",
                    "Policy #",
                    "Expiration",
                    "Remaining Days",
                    "",
                    "",
                ]);
                item.insuranceDetails.forEach((detail) => {
                    data.push([
                        "",
                        "",
                        `${detail.coverageType || ""}`,
                        `${detail.policyNumber || ""}`,
                        `${detail.expirationDate
                            ? new Date(detail.expirationDate).toLocaleDateString()
                            : "N/A"
                        }`,
                        `${detail.daysRemaining || "N/A"}`,
                        "",
                        "",
                    ]);
                });
            }
        });

        setSelectedCol(headers);
        setSelectedColData(data);
        setExcelShowHide(true);
    };

    const handlepdfShowHide = () => {
        setPdfShowHide(false);
        setSelectedCol("");
        setSelectedColData([]);
    };

    const handleexcelShowHide = () => {
        setExcelShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const renderClipboardIcon = (val) => {
        if (!val) return null;
        return copiedText === val ? (
            <i className="fa fa-check text-success ins-copy-btn" title="Copied!"></i>
        ) : (
            <i
                className="fa fa-clipboard ins-copy-btn"
                title="Copy policy number"
                onClick={() => copyToClipboard(val)}
            ></i>
        );
    };

    return (
        <div className="ins-report-container">
            <style>{`
                .ins-report-container {
                    font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
                    color: #1e293b;
                    margin-bottom: 2rem;
                }

                /* Visual selector cards */
                .ins-card-selector {
                    margin-bottom: 14px;
                }

                .ins-select-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 14px;
                    padding: 13px 16px;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 14px;
                    transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
                    height: 100%;
                    position: relative;
                }

                .ins-select-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 20px -4px rgba(15, 23, 42, 0.06);
                    border-color: #cbd5e1;
                }

                .ins-select-card.active {
                    background: #ffffff !important;
                    border: 1.5px solid #171717 !important;
                    box-shadow: 0 6px 18px -4px rgba(15, 23, 42, 0.08), inset 4px 0 0 0 #171717 !important;
                }

                .ins-select-card.active .ins-select-card-title {
                    color: #1e293b !important;
                    font-weight: 500 !important;
                }

                .ins-select-card.active .ins-select-card-desc {
                    color: #525252 !important;
                }

                .ins-select-card-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    flex-shrink: 0;
                    background: #f5f5f5;
                    color: #171717;
                    border: 1px solid #d4d4d4;
                    transition: all 0.2s ease;
                }

                .ins-select-card.active .ins-select-card-icon {
                    background: #171717 !important;
                    color: #ffffff !important;
                    border-color: #171717 !important;
                }

                .ins-card-check-badge {
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    width: 18px;
                    height: 18px;
                    border-radius: 50%;
                    background: #171717;
                    color: #ffffff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                    animation: badgePop 0.2s cubic-bezier(0.4, 0, 0.2, 1);
                }

                @keyframes badgePop {
                    from { transform: scale(0.6); opacity: 0; }
                    to   { transform: scale(1); opacity: 1; }
                }

                .ins-select-card:hover .ins-select-card-icon {
                    transform: scale(1.05);
                }

                .ins-select-card-title {
                    font-size: 14px;
                    font-weight: 500;
                    color: #1e293b;
                    margin-bottom: 2px;
                }

                .ins-select-card-desc {
                    font-size: 14px;
                    font-weight: 400;
                    color: #64748b;
                    line-height: 1.3;
                }

                /* KPI Metric display cards */
                .ins-kpi-row {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
                    gap: 16px;
                    margin-bottom: 14px;
                }

                .ins-metric-card {
                    background: #ffffff;
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    padding: 14px 18px;
                    display: flex;
                    align-items: center;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.01);
                }

                .ins-metric-icon {
                    width: 38px;
                    height: 38px;
                    border-radius: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    margin-right: 14px;
                    background: #f5f5f5;
                    color: #171717;
                    border: 1px solid #d4d4d4;
                    flex-shrink: 0;
                }

                .ins-metric-val {
                    font-size: 18px;
                    font-weight: 500;
                    color: #1e293b;
                    line-height: 1.1;
                    margin-bottom: 2px;
                }

                .ins-metric-label {
                    font-size: 12px;
                    color: #64748b;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.02em;
                }

                /* Controls Layout */
                .ins-report-controls {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    gap: 1rem;
                    margin-bottom: 14px;
                    background-color: #fafbfc;
                    border: 1px solid #e2e8f0;
                    border-radius: 10px;
                    padding: 14px 18px;
                }

                .ins-controls-group {
                    display: flex;
                    align-items: center;
                    gap: 10px;
                    flex-wrap: wrap;
                }

                .ins-search-wrapper {
                    position: relative;
                    width: 240px;
                }

                .ins-search-input {
                    width: 100%;
                    padding: 8px 12px 8px 34px;
                    background: #ffffff;
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #1e293b;
                    transition: all 0.2s ease;
                }

                .ins-search-input:focus {
                    outline: none;
                    border-color: #171717;
                    box-shadow: 0 0 0 3px rgba(23, 23, 23, 0.1);
                }

                .ins-search-icon {
                    position: absolute;
                    left: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #94a3b8;
                    font-size: 12px;
                }

                .ins-filter-select {
                    height: 35px;
                    border: 1px solid #cbd5e1;
                    border-radius: 8px;
                    padding: 0 10px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #1e293b;
                    background: #ffffff;
                }

                .ins-filter-select:focus {
                    outline: none;
                    border-color: #171717;
                }

                .ins-actions-btns {
                    display: flex;
                    align-items: center;
                }

                .ins-actions-btns > * {
                    margin-right: 8px !important;
                }

                .ins-actions-btns > *:last-child {
                    margin-right: 0 !important;
                }

                .ins-report-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 7px 14px;
                    border-radius: 0;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #1e293b;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                }

                .ins-report-btn:hover:not(:disabled) {
                    background-color: #f5f5f5;
                    color: #1e293b;
                    border-color: #94a3b8;
                }

                .ins-report-btn:disabled {
                    background-color: #f1f5f9;
                    border-color: #e2e8f0;
                    color: #94a3b8;
                    cursor: not-allowed;
                }

                /* Table modifications matching WorkflowUser */
                .ins-report-table-wrapper {
                    border: 1px solid #e2e8f0;
                    border-radius: 12px;
                    overflow-x: auto;
                    overflow-y: hidden;
                    background: white;
                    box-shadow: 0 4px 12px rgba(0,0,0,0.01);
                }

                .ins-report-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 14px;
                    text-align: left;
                }

                .ins-report-table thead {
                    background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%) !important;
                }

                .ins-report-table thead tr {
                    background: transparent !important;
                }

                .ins-report-table th {
                    background: transparent !important;
                    background-color: transparent !important;
                    color: #64748b !important;
                    font-weight: 600 !important;
                    font-size: 12px !important;
                    text-transform: uppercase !important;
                    letter-spacing: 0.6px !important;
                    padding: 13px 16px !important;
                    border-bottom: 2px solid #e2e8f0 !important;
                    border-top: none !important;
                    border-left: none !important;
                    border-right: none !important;
                    white-space: nowrap !important;
                }

                .ins-report-table tbody tr {
                    transition: background 0.15s ease, box-shadow 0.15s ease !important;
                }

                .ins-report-table tbody tr:hover {
                    background: linear-gradient(90deg, #f5f5f5 0%, #fafafa 100%) !important;
                    box-shadow: inset 3px 0 0 0 #171717 !important;
                }

                .ins-report-table tbody tr:hover td {
                    color: #1e293b !important;
                }

                .ins-report-table td {
                    padding: 13px 16px !important;
                    font-size: 14px !important;
                    font-weight: 400 !important;
                    color: #1e293b !important;
                    border-bottom: 1px solid #f1f5f9 !important;
                    vertical-align: middle !important;
                    transition: color 0.15s ease !important;
                    white-space: nowrap !important;
                }

                .ins-report-table tbody tr:last-child td {
                    border-bottom: none !important;
                }

                .ins-report-empty {
                    padding: 4rem 2rem;
                    text-align: center;
                    color: #94a3b8;
                    border: 2px dashed #e2e8f0;
                    border-radius: 12px;
                    background-color: #f8fafc;
                }

                .ins-copy-btn {
                    color: #94a3b8;
                    cursor: pointer;
                    margin-left: 6px;
                    transition: all 0.15s ease;
                    font-size: 12px;
                }

                .ins-copy-btn:hover {
                    color: #1e293b;
                }

                .ins-view-btn {
                    display: inline-flex;
                    align-items: center;
                    justify-content: center;
                    gap: 6px;
                    padding: 7px 14px;
                    border-radius: 0;
                    font-size: 14px;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.15s ease;
                    border: 1px solid #cbd5e1;
                    background: #ffffff;
                    color: #1e293b;
                    outline: none;
                    box-shadow: 0 2px 5px rgba(15, 23, 42, 0.08);
                }

                .ins-view-btn:hover {
                    background-color: #f5f5f5;
                    color: #1e293b;
                    border-color: #94a3b8;
                }

                .ins-view-btn i {
                    font-size: 12px;
                    color: #1e293b;
                }

                /* Scrollbar styled matching left side menu */
                .ins-report-table-wrapper::-webkit-scrollbar,
                .ach-report-body div::-webkit-scrollbar {
                    width: 6px !important;
                    height: 6px !important;
                }

                .ins-report-table-wrapper::-webkit-scrollbar-track,
                .ach-report-body div::-webkit-scrollbar-track {
                    background: transparent !important;
                }

                .ins-report-table-wrapper::-webkit-scrollbar-thumb,
                .ach-report-body div::-webkit-scrollbar-thumb {
                    background: linear-gradient(180deg, #94a3b8, #cbd5e1) !important;
                    border-radius: 20px !important;
                    transition: all 0.2s ease !important;
                }

                .ins-report-table-wrapper::-webkit-scrollbar-thumb:hover,
                .ach-report-body div::-webkit-scrollbar-thumb:hover {
                    background: linear-gradient(180deg, #64748b, #94a3b8) !important;
                }

                /* ToolsPopup style replica for Insurance details popup */
                .modal-backdrop.show {
                  backdrop-filter: blur(8px) !important;
                  -webkit-backdrop-filter: blur(8px) !important;
                  background-color: rgba(15, 23, 42, 0.45) !important;
                  opacity: 1 !important;
                }

                .modal.fade .ins-tools-modal.modal-dialog {
                  transform: scale(0.95) !important;
                  transition: transform 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
                }
                .modal.show .ins-tools-modal.modal-dialog {
                  transform: scale(1) !important;
                }

                .ins-tools-modal {
                  --task-accent: #06b6d4;
                  --task-soft: #ecfeff;
                  max-width: 90% !important;
                  width: 1000px !important;
                }

                .ins-tools-modal .modal-content {
                  border-radius: 12px !important;
                  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
                  overflow: hidden !important;
                  background: #ffffff !important;
                  border: none !important;
                }

                .ins-tools-modal .modal-header {
                  position: relative !important;
                  display: block !important;
                  padding: 24px 28px 20px 32px !important;
                  background: linear-gradient(90deg, var(--task-soft) 0%, rgba(255,255,255,0.98) 54%, #ffffff 100%) !important;
                  border-bottom: 1px solid #edf2f7 !important;
                  overflow: hidden !important;
                }

                .ins-tools-modal .modal-header::before {
                  content: "" !important;
                  position: absolute !important;
                  top: 0 !important;
                  left: 0 !important;
                  bottom: 0 !important;
                  width: 4px !important;
                  background: var(--task-accent) !important;
                }

                .ins-tools-modal .rt-header-shell {
                  display: flex !important;
                  flex-direction: column !important;
                  gap: 14px !important;
                  width: 100% !important;
                }

                .ins-tools-modal .rt-header-top {
                  display: flex !important;
                  justify-content: space-between !important;
                  align-items: flex-start !important;
                  gap: 18px !important;
                  width: 100% !important;
                }

                .ins-tools-modal .rt-header-main {
                  display: flex !important;
                  align-items: center !important;
                  gap: 14px !important;
                  min-width: 0 !important;
                  flex: 1 1 auto !important;
                }

                .ins-tools-modal .rt-header-copy {
                  display: flex !important;
                  flex-direction: column !important;
                  gap: 8px !important;
                  min-width: 0 !important;
                  padding-top: 4px !important;
                }

                .ins-tools-modal .rt-modal-title {
                  display: inline-flex !important;
                  align-items: center !important;
                  margin: 0 !important;
                  color: #1e293b !important;
                  font-size: 18px !important;
                  font-weight: 500 !important;
                  line-height: 1.2 !important;
                  min-width: 0 !important;
                }

                .ins-tools-modal .rt-header-icon {
                  width: 52px !important;
                  height: 52px !important;
                  min-height: 52px !important;
                  border-radius: 10px !important;
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  color: var(--task-accent) !important;
                  background: #ffffff !important;
                  border: 1px solid var(--task-accent) !important;
                  box-shadow: 0 8px 18px -12px rgba(15,23,42,0.28) !important;
                  font-size: 18px !important;
                  flex-shrink: 0 !important;
                }

                .ins-tools-modal .rt-modal-title-text {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 12px !important;
                  min-width: 0 !important;
                  flex-wrap: wrap !important;
                }

                .ins-tools-modal .rt-modal-title-badge {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  padding: 4px 10px !important;
                  border-radius: 999px !important;
                  font-size: 12px !important;
                  font-weight: 600 !important;
                  text-transform: uppercase !important;
                  letter-spacing: 0.02em !important;
                  background: var(--task-soft) !important;
                  color: var(--task-accent) !important;
                  border: 1px solid #e2e8f0 !important;
                }

                .ins-tools-modal .rt-modal-meta-row {
                  display: flex !important;
                  align-items: center !important;
                  flex-wrap: wrap !important;
                  gap: 10px 12px !important;
                  margin-top: 0 !important;
                  padding-left: 0 !important;
                  font-size: 12px !important;
                  color: #64748b !important;
                }

                .ins-tools-modal .rt-meta-chip {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 6px !important;
                  background: #ffffff !important;
                  padding: 5px 10px !important;
                  border-radius: 8px !important;
                  font-size: 14px !important;
                  font-weight: 400 !important;
                  color: #1e293b !important;
                  border: 1px solid #e2e8f0 !important;
                  box-shadow: 0 1px 3px rgba(15,23,42,0.04) !important;
                }

                .ins-tools-modal .rt-meta-chip i {
                  color: var(--task-accent) !important;
                  font-size: 11px !important;
                }

                .ins-tools-modal .rt-meta-divider {
                  width: 1px !important;
                  height: 16px !important;
                  background: #cbd5e1 !important;
                  margin: 0 4px !important;
                }

                .ins-tools-modal .rt-meta-desc {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 6px !important;
                  color: #64748b !important;
                  font-size: 14px !important;
                  font-weight: 400 !important;
                  line-height: 1.4 !important;
                }

                .ins-tools-modal .rt-meta-desc i {
                  color: var(--task-accent) !important;
                }

                .ins-tools-modal .modal-body {
                  padding: 24px !important;
                  background: #f8fafc !important;
                  max-height: calc(100vh - 180px) !important;
                  overflow-y: auto !important;
                }

                .ins-tools-modal .rt-action-btn {
                  display: inline-flex !important;
                  align-items: center !important;
                  justify-content: center !important;
                  width: 40px !important;
                  height: 40px !important;
                  padding: 0 !important;
                  font-size: 14px !important;
                  font-weight: 500 !important;
                  color: #64748b !important;
                  background: #ffffff !important;
                  border: 1px solid #cbd5e1 !important;
                  border-radius: 8px !important;
                  cursor: pointer !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
                  outline: none !important;
                }

                .ins-tools-modal .rt-action-btn:hover {
                  color: #1e293b !important;
                  border-color: #94a3b8 !important;
                  background: #f8fafc !important;
                  transform: translateY(-1px) !important;
                  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
                }

                .ins-tools-modal .rt-action-btn i {
                  font-size: 11px !important;
                  color: #94a3b8 !important;
                  transition: color 0.2s ease !important;
                }

                .ins-tools-modal .rt-action-btn:hover i {
                  color: #ef4444 !important;
                }

                .ins-tools-modal .modal-footer {
                  background: #f8fafc !important;
                  border-top: 1px solid #edf2f7 !important;
                  padding: 16px 24px !important;
                  display: flex !important;
                  justify-content: flex-end !important;
                }

                .ins-tools-modal .wf-modal-footer-close-btn {
                  display: inline-flex !important;
                  align-items: center !important;
                  gap: 7px !important;
                  padding: 7px 14px !important;
                  font-size: 14px !important;
                  font-weight: 500 !important;
                  color: #1e293b !important;
                  background: #ffffff !important;
                  border: 1px solid #cbd5e1 !important;
                  border-radius: 8px !important;
                  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.05) !important;
                  outline: none !important;
                  cursor: pointer !important;
                  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
                }

                .ins-tools-modal .wf-modal-footer-close-btn:hover {
                  background: #f8fafc !important;
                  color: #1e293b !important;
                  border-color: #94a3b8 !important;
                  transform: translateY(-1px) !important;
                  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
                }

                .ins-tools-modal .wf-modal-footer-close-btn i {
                  font-size: 11px !important;
                  color: #94a3b8 !important;
                }
                .ins-tools-modal .wf-modal-footer-close-btn:hover i {
                  color: #ef4444 !important;
                }

                /* Shimmer and Loading Animation */
                @keyframes shimmer {
                  0%   { background-position: -600px 0; }
                  100% { background-position: 600px 0; }
                }

                @keyframes loadingBar {
                  0%   { width: 0%; opacity: 1; }
                  70%  { width: 85%; opacity: 1; }
                  100% { width: 100%; opacity: 0; }
                }

                .wf-loading-bar {
                  position: absolute;
                  top: 0;
                  left: 0;
                  right: 0;
                  height: 3px;
                  background: linear-gradient(90deg, #171717, #525252, #171717);
                  background-size: 200% 100%;
                  animation: loadingBar 1.6s ease-in-out infinite;
                  z-index: 10;
                }

                .skeleton-cell {
                  display: block;
                  height: 12px;
                  border-radius: 6px;
                  background: linear-gradient(
                    90deg,
                    #f1f5f9 25%,
                    #e2e8f0 50%,
                    #f1f5f9 75%
                  );
                  background-size: 600px 100%;
                  animation: shimmer 1.4s ease-in-out infinite;
                }

                .skeleton-cell.sk-short  { width: 40%; }
                .skeleton-cell.sk-medium { width: 65%; }
                .skeleton-cell.sk-long   { width: 85%; }
                .skeleton-cell.sk-full   { width: 92%; }

                .skeleton-row td {
                  padding: 14px 16px !important;
                }

                /* Enhanced empty state */
                .wf-empty-state {
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  padding: 50px 24px;
                  text-align: center;
                  gap: 12px;
                }

                .wf-roles-empty-state {
                  min-height: 250px;
                  width: 100%;
                }

                .wf-empty-icon {
                  width: 52px;
                  height: 52px;
                  border-radius: 14px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 22px;
                  background: linear-gradient(135deg, rgba(79, 70, 229, 0.08) 0%, rgba(14, 165, 233, 0.06) 100%);
                  border: 1px solid rgba(79, 70, 229, 0.12);
                  color: #4f46e5;
                  margin-bottom: 4px;
                }

                .wf-empty-title {
                  font-size: 14px;
                  font-weight: 500;
                  color: #1e293b;
                  margin: 0;
                  width: 100%;
                  text-align: center;
                }

                .wf-empty-desc {
                  font-size: 14px;
                  font-weight: 400;
                  color: #64748b;
                  margin: 0 auto;
                  line-height: 1.6;
                  text-align: center;
                  width: 100%;
                }

                .ins-select-card.loading {
                    pointer-events: none;
                    opacity: 0.7;
                }

                .ach-pay-loading-status {
                    display: inline-flex;
                    align-items: center;
                    gap: 8px;
                    font-size: 14px;
                    font-weight: 400;
                    color: #64748b;
                    margin-right: 10px;
                }

                .ach-pay-loading-status i {
                    color: #1e293b;
                }

            `}</style>

            <div className="ins-card-selector">
                <div className="row">
                    {insuranceTypes.map((t) => {
                        const isActive = Number(selectedInsuranceType) === t.pmId;
                        const icons = {
                            3: "fa-handshake-o",
                            5: "fa-briefcase"
                        };

                        return (
                            <div className="col-md-6 mb-3" key={t.id}>
                                <div
                                    className={`ins-select-card ${isActive ? "active" : ""} ${isLoading ? "loading" : ""}`}
                                    onClick={() => handleInsuranceTypeSelect(t.pmId)}
                                >
                                    {isActive && !isLoading && (
                                        <div className="ins-card-check-badge">
                                            <i className="fa fa-check"></i>
                                        </div>
                                    )}
                                    {isActive && isLoading && (
                                        <div className="ins-card-check-badge">
                                            <i className="fa fa-spinner fa-spin"></i>
                                        </div>
                                    )}
                                    <div className="ins-select-card-icon">
                                        <i className={`fa ${icons[t.pmId]}`}></i>
                                    </div>
                                    <div className="ins-select-card-body" style={{ flexGrow: 1, minWidth: 0, paddingRight: isActive ? "14px" : "0" }}>
                                        <div className="ins-select-card-title">{t.name}</div>
                                        <div className="ins-select-card-desc">
                                            {t.pmId === 3 && "Audit insurance credentials for partner Subcontractors."}
                                            {t.pmId === 5 && "Track insurance policy dates and coverage for Recruiter organizations."}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            {selectedInsuranceType !== 0 && (
                <div className="ach-report-body p-0">
                    <div className="ins-report-controls">
                        <div className="ins-controls-group">
                            <div className="ins-search-wrapper">
                                <i className="fa fa-search ins-search-icon"></i>
                                <input
                                    type="text"
                                    placeholder="Search by company or key contact..."
                                    className="ins-search-input"
                                    value={tableSearchTerm}
                                    onChange={(e) => setTableSearchTerm(e.target.value)}
                                />
                            </div>

                            <SearchableSelect
                                id="insuranceExpired"
                                name="insuranceExpired"
                                value={insuranceExpired}
                                onChange={(e) => handleInsuranceExpiredChange(e)}
                                options={expirationOptions}
                                placeholder="Expiration Status..."
                                size="sm"
                                width="190px"
                                icon="fa-filter"
                            />
                        </div>

                        <div className="ins-actions-btns">
                            {isLoading && (
                                <div className="ach-pay-loading-status">
                                    <i className="fa fa-spinner fa-spin"></i>
                                    <span>Loading insurance records...</span>
                                </div>
                            )}
                            <button
                                type="button"
                                className="ins-report-btn ins-report-btn-secondary"
                                disabled={isLoading || filteredReports?.length === 0}
                                onClick={subcontractorExportExcel}
                            >
                                <i className="fa fa-file-excel-o" style={{ color: "#1e293b", marginRight: "6px" }} aria-hidden="true"></i>
                                Excel Export
                            </button>
                            <button
                                type="button"
                                className="ins-report-btn ins-report-btn-secondary"
                                disabled={isLoading || filteredReports?.length === 0}
                                onClick={subcontractorExportPDF}
                            >
                                <i className="fa fa-file-pdf-o" style={{ color: "#1e293b", marginRight: "6px" }}></i>
                                Export PDF
                            </button>
                        </div>
                    </div>

                    {selectedInsuranceType !== 0 && parterInsuranceReports && parterInsuranceReports.length > 0 && (
                        <div className="ins-kpi-row" style={{ marginTop: "12px", marginBottom: "14px" }}>
                            <div className="ins-metric-card">
                                <div className="ins-metric-icon">
                                    <i className="fa fa-users"></i>
                                </div>
                                <div>
                                    <div className="ins-metric-val">{totalCount}</div>
                                    <div className="ins-metric-label">Total Records</div>
                                </div>
                            </div>
                            <div className="ins-metric-card">
                                <div className="ins-metric-icon">
                                    <i className="fa fa-university"></i>
                                </div>
                                <div>
                                    <div className="ins-metric-val">{uniqueInsurers}</div>
                                    <div className="ins-metric-label">Insurers</div>
                                </div>
                            </div>
                            <div className="ins-metric-card">
                                <div className="ins-metric-icon">
                                    <i className="fa fa-exclamation-triangle"></i>
                                </div>
                                <div>
                                    <div className="ins-metric-val">{expiredCount}</div>
                                    <div className="ins-metric-label">Expired Partners</div>
                                </div>
                            </div>
                            <div className="ins-metric-card">
                                <div className="ins-metric-icon">
                                    <i className="fa fa-check-circle-o"></i>
                                </div>
                                <div>
                                    <div className="ins-metric-val">{activeCount}</div>
                                    <div className="ins-metric-label">Compliant Partners</div>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Synchronized top scrollbar */}
                    {parterInsuranceReports && parterInsuranceReports.length > 0 && filteredReports.length > 0 && (
                        <div
                            ref={topScrollRef}
                            onScroll={handleTopScroll}
                            style={{ overflowX: "auto", overflowY: "hidden", height: "14px", width: "100%", marginBottom: "4px" }}
                        >
                            <div style={{ width: `${tableWidth}px`, height: "1px" }}></div>
                        </div>
                    )}

                    <div
                        ref={tableWrapperRef}
                        onScroll={handleTableScroll}
                        className="ins-report-table-wrapper"
                        style={{ position: "relative" }}
                    >
                        {isLoading && <div className="wf-loading-bar" />}

                        {selectedInsuranceType === 0 ? (
                            <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                    <i className="fa fa-info-circle"></i>
                                </div>
                                <p className="wf-empty-title">No Category Selected</p>
                                <p className="wf-empty-desc">Select an entity category above to inspect Insurance registries.</p>
                            </div>
                        ) : isLoading ? (
                            /* SKELETON TABLE */
                            <table className="ins-report-table">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Company Name</th>
                                        <th>Company Email</th>
                                        <th>Company Phone</th>
                                        <th>Insurance Company</th>
                                        <th>Insurance Details</th>
                                        <th>Key Contact ID</th>
                                        <th>Key Contact Name</th>
                                        <th>Key Contact Email</th>
                                        <th>Key Contact Phone</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[1, 2, 3, 4, 5].map((i) => (
                                        <tr key={`skel-${i}`} className="skeleton-row">
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                            <td><span className="skeleton-cell sk-short" style={{ animationDelay: `${i * 0.05}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.07}s` }} /></td>
                                            <td><span className="skeleton-cell sk-long" style={{ animationDelay: `${i * 0.06}s` }} /></td>
                                            <td><span className="skeleton-cell sk-medium" style={{ animationDelay: `${i * 0.08}s` }} /></td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : parterInsuranceReports && parterInsuranceReports.length > 0 ? (
                            filteredReports.length > 0 ? (
                                <table
                                    className="ins-report-table"
                                    id="sub_ach_rpt"
                                >
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Company Name</th>
                                            <th>Company Email</th>
                                            <th>Company Phone</th>
                                            <th>Insurance Company</th>
                                            <th>Insurance Details</th>
                                            <th>Key Contact ID</th>
                                            <th>Key Contact Name</th>
                                            <th>Key Contact Email</th>
                                            <th>Key Contact Phone</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredReports.map((item, index) => (
                                            <tr key={item.id || index}>
                                                <td>{item.id}</td>
                                                <td>{item.name}</td>
                                                <td>{item.email}</td>
                                                <td>{item.phone && getFormatedNumber(item.phone)}</td>
                                                <td>{item.insuranceCompany || <em className="text-muted">Not provided</em>}</td>
                                                <td>
                                                    <button
                                                        className="ins-view-btn"
                                                        onClick={() => handleViewDetails(item)}
                                                    >
                                                        <i className="fa fa-eye"></i> View Details
                                                    </button>
                                                </td>
                                                <td>{item.keyId}</td>
                                                <td>{item.keyName}</td>
                                                <td>{item.keyEmail}</td>
                                                <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            ) : (
                                <div className="wf-empty-state">
                                    <div className="wf-empty-icon">
                                        <i className="fa fa-search"></i>
                                    </div>
                                    <p className="wf-empty-title">No Matching Records</p>
                                    <p className="wf-empty-desc">No records matched your search query. Try adjusting your search term.</p>
                                </div>
                            )
                        ) : (
                            <div className="wf-empty-state">
                                <div className="wf-empty-icon">
                                    <i className="fa fa-folder-open-o"></i>
                                </div>
                                <p className="wf-empty-title">No Data Found</p>
                                <p className="wf-empty-desc">No insurance records found for this category on the server.</p>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* Detailed Policies Modal Popup */}
            <Modal
                show={showDetailsModal}
                onHide={handleCloseDetailsModal}
                size="lg"
                dialogClassName="ins-tools-modal"
                centered
            >
                <Modal.Header>
                    <div className="rt-header-shell">
                        <div className="rt-header-top">
                            <div className="rt-header-main">
                                <i className="rt-header-icon fa fa-shield" aria-hidden="true" />
                                <div className="rt-header-copy">
                                    <h2 className="rt-modal-title">
                                        <span className="rt-modal-title-text">
                                            <span>Insurance Policies & Coverage</span>
                                            <span className="rt-modal-title-badge">
                                                Compliance
                                            </span>
                                        </span>
                                    </h2>
                                    {activeDetailsItem && (
                                        <div className="rt-modal-meta-row">
                                            <span className="rt-meta-chip">
                                                <i className="fa fa-user" aria-hidden="true" /> {activeDetailsItem.name}
                                            </span>
                                            <span className="rt-meta-chip">
                                                <i className="fa fa-tag" aria-hidden="true" /> ID: {activeDetailsItem.id}
                                            </span>
                                            <span className="rt-meta-divider" />
                                            <span className="rt-meta-desc">
                                                <i className="fa fa-info-circle" aria-hidden="true" /> Carrier: {activeDetailsItem.insuranceCompany || "Not specified"}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <button
                                type="button"
                                className="rt-action-btn"
                                onClick={handleCloseDetailsModal}
                                title="Close Details"
                            >
                                <i className="fa fa-times" aria-hidden="true" />
                            </button>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body style={{ background: "#f8fafc", padding: "24px" }}>
                    {activeDetailsItem && (
                        <div className="ins-detail-panel">
                            {activeDetailsItem.insuranceDetails && activeDetailsItem.insuranceDetails.length > 0 ? (
                                <div className="row">
                                    {activeDetailsItem.insuranceDetails.map((detail, keyIdx) => {
                                        const days = detail.daysRemaining;
                                        const isExpired = days !== null && days <= 0;
                                        const isWarning = days !== null && days > 0 && days <= 30;

                                        let badgeBg = "#10b981";
                                        let badgeText = "Active";

                                        if (isExpired) {
                                            badgeBg = "#ef4444";
                                            badgeText = "Expired";
                                        } else if (isWarning) {
                                            badgeBg = "#f59e0b";
                                            badgeText = `Expiring soon (${days} days)`;
                                        } else if (days !== null) {
                                            badgeText = `Active (${days} days)`;
                                        }

                                        return (
                                            <div className="col-md-6 mb-3" key={keyIdx}>
                                                <div
                                                    className="p-3 border rounded h-100 d-flex flex-column justify-content-between bg-white"
                                                    style={{
                                                        borderRadius: "10px",
                                                        borderColor: isExpired ? "#fecaca" : isWarning ? "#fde68a" : "#e2e8f0",
                                                        boxShadow: "0 2px 4px rgba(0,0,0,0.01)"
                                                    }}
                                                >
                                                    <div>
                                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                                            <span style={{ fontWeight: 500, fontSize: "14px", color: "#1e293b" }}>
                                                                {detail.coverageType}
                                                            </span>
                                                            <span className="badge text-white" style={{ background: badgeBg, fontSize: "12px", fontWeight: 600, padding: "3px 8px", borderRadius: "12px" }}>
                                                                {badgeText}
                                                            </span>
                                                        </div>
                                                        <div style={{ fontSize: "14px", fontWeight: 400, color: "#64748b", marginBottom: "4px" }}>
                                                            <strong style={{ fontWeight: 500, color: "#1e293b" }}>Policy #:</strong> {detail.policyNumber || "N/A"}
                                                            {detail.policyNumber && renderClipboardIcon(detail.policyNumber)}
                                                        </div>
                                                    </div>
                                                    <div className="border-top pt-2 mt-3" style={{ fontSize: "14px", fontWeight: 400, color: "#64748b" }}>
                                                        <i className="fa fa-calendar-o mr-1"></i>
                                                        Expires: {detail.expirationDate ? (
                                                            <Moment format="MMM Do, YYYY">
                                                                {detail.expirationDate}
                                                            </Moment>
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="text-center py-5 text-muted bg-white border rounded" style={{ borderRadius: "12px" }}>
                                    <i className="fa fa-folder-open-o fa-3x mb-3 d-block text-muted"></i>
                                    <small>No policy details registered for this company.</small>
                                </div>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button
                        type="button"
                        className="wf-modal-footer-close-btn"
                        onClick={handleCloseDetailsModal}
                    >
                        <i className="fa fa-times" aria-hidden="true" />
                        Close
                    </button>
                </Modal.Footer>
            </Modal>

            <GeneratePdf
                handlepdfShowHide={handlepdfShowHide}
                pdfShowHide={pdfShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GeneratePdf>
            <GenerateExcel
                handleexcelShowHide={handleexcelShowHide}
                excelShowHide={excelShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GenerateExcel>
        </div>
    );
};

export default InsuranceInformation;